import React from 'react';
import Topbar from './Topbar';
import Sidebar from './Sidebar';

interface LayoutProps {
  children: React.ReactNode;
  hideChrome?: boolean; // hide sidebar/topbar (e.g., for login)
}

const Layout: React.FC<LayoutProps> = ({ children, hideChrome }) => {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  if (hideChrome) {
    return <div className="min-h-screen bg-gray-50">{children}</div>;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Topbar onToggleSidebar={() => setSidebarOpen(v => !v)} />
      <div className="flex">
        <Sidebar open={sidebarOpen} />
        <main className="flex-1 min-w-0 lg:ml-0 lg:w-[calc(100%-18rem)] p-4 lg:p-6">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
